<template>
  <div class="comp-password">
    <div class="header" @click="handleBack"> 
      <a-icon type="left"></a-icon>
      返回 
    </div>
    <div class="content">
      <div class="title">修改密码</div>
      <a-input 
        v-model="account"
        class="row-item" 
        placeholder="账号"></a-input>
      <a-input-password 
        v-model="originPassword"
        class="row-item" 
        type="password" 
        placeholder="原密码"></a-input-password>
      <a-input-password 
        v-model="newPassword"
        class="row-item" 
        type="password" 
        placeholder="新密码"></a-input-password>
      <div v-if="!checkPassword(newPassword)" class="error-note">
        密码需要至少8~16个字符，至少一个大写字母，至少一个小写字母，至少一个数字，不能包含大小写字母数字外其他字符。
      </div>
      <a-button 
        class="row-item btn" 
        type="primary" 
        block
        :disabled="!checkPassword(newPassword)"
        @click="handleSubmit()">
        修改密码
      </a-button>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { changePassword } from '../api/index'

export default {
  name: 'Password',
  components: {
  },
  data(){
    return {
      account: '',
      originPassword: '',
      newPassword: '',
    }
  },
  methods: {
    checkPassword(value) {
      if ([null, '', undefined].includes(value)) {
        return false
      }
      if (/[\S\s]{8,16}/.test(value) && /[\d.]/.test(value) && /[.a-z]/.test(value) && /[.A-Z]/.test(value) && !/[^0-9a-zA-Z]/.test(value)) {
        return true
      } else {
        return false
      }
    },
    handleBack() {
      this.$router.back()
    },
    async handleSubmit() {
      if(!this.account){
        message.error('账号不能为空')
        return
      }
      if(!this.originPassword || !this.newPassword){
        message.error('原密码/新密码不能为空')
        return
      }

      const passData = {
        username: this.account,
        original_password: this.originPassword,
        new_password: this.newPassword,
      }

      const response = await changePassword({ data: passData })
      if(response.status === 200) {
        if(response.data.success) {
          this.$store.commit('clearUserInfo')
          this.$store.commit('clearToken')
          this.$router.push('/login')
        } 
      }

    }
  }
  
}
</script>
<style lang="less">
.comp-password {
  height: calc(100vh - 66px);
  width: 100vw;
  position: relative;
  background-image: url('~@/assets/background.png');
  background-repeat: repeat;
  background-size: 600px 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  .header {
    position: absolute;
    left: 20px;
    top: 20px;
    font-family: 'Microsoft YaHei UI';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    cursor: pointer;
  }
  .content{
    width: 494px;
    .title {
      font-family: 'Microsoft YaHei UI';
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 36px;
      /* identical to box height, or 180% */

      text-align: center;
      letter-spacing: -0.015em;
    }
    .row-item {
      margin-top: 40px;
      height:60px;
    }

    .btn {
      background: #0072BE;
      font-family: 'Microsoft YaHei UI';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 25px;
      text-align: center;
      letter-spacing: -0.015em;
    }
    .ant-input {
      height: 60px;
    }

    .error-note {
      margin-top: 10px;
      font-size: 16px;
    }
  }
  
}
</style>
